import { yes, no } from '../constants/form-controls';

export function convertRadioToBoolean(checked: string) {
    return checked === yes ? true : checked === no ? false : null;
}